import { render, staticRenderFns } from "./UnManagedSection.vue?vue&type=template&id=3f6775a6&scoped=true&"
import script from "./UnManagedSection.vue?vue&type=script&lang=ts&"
export * from "./UnManagedSection.vue?vue&type=script&lang=ts&"
import style0 from "./UnManagedSection.vue?vue&type=style&index=0&id=3f6775a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6775a6",
  null
  
)

export default component.exports